import templateAdmin from '../../../../../Template/config/components/adminView'

export default {
    ...templateAdmin
}